export const derivePulseOpportunitiesState = (param)=>{
    let { hasFailedWithNothingToShow, isLoading, isEmpty } = param;
    if (hasFailedWithNothingToShow) return 'error';
    if (isLoading) return 'loading';
    if (isEmpty) return 'empty';
    return 'populated';
};
